<template>
    <div class="caseCont" :class="theme">
        <div class="layout">
            <h6>看看和你背景相似的同学去了哪里</h6>
            <div class="flex-end" style="margin: 36px 0 20px;">
                <p class="refresh pointer flex-ac">
                    <RefreshRight style="width: 16px; height: 16px; margin-right: 6px" />换一批
                </p>
            </div>
            <div class="flex-ac flex-start fw" style="gap: 20px 20px;">
                <div v-for="(it, i) in caseList" class="caseItem" :key="i">
                    <p class="name">{{ it.name }}</p>
                    <p class="similarity">相似度：{{ it.similarity }}</p>
                    <p class="byxx flex-ac">{{ it.byxx }} GPA:{{ it.gpa }}</p>
                    <div class="line"></div>
                    <p class="lqsj">{{ $formatDate(it.lqsj, 'yyyy年MM月') }}<i>成功入读</i></p>
                    <p class="lqxx">{{ it.lqxx }}</p>
                    <p class="lqzz">{{ it.lqzz }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {
    ref,
    computed,
    onMounted,
    onBeforeMount,
    onBeforeUnmount,
    watch,
} from "vue";


import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const store = useStore();
const { theme } = storeToRefs(store);

const caseList = ref([
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
    { name: '林同学', similarity: '98%', byxx: '广东工业大学', gpa: '80', lqsj: new Date(), lqxx: '英国伦敦大学', lqzz: '计算机专业' },
])
</script>
<style lang="scss" scoped>
.caseCont {
    padding: 80px 0 90px;
    background: #F8FAFC;

    h6 {
        color: #393D4B;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin: 0 auto;
    }

    .caseItem {
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 14, 67, 0.06);
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #EDF5FF;
        padding: 20px;
        width: calc(25% - 15px);

        @media (max-width: 1000px) {
            width: calc(33% - 14px);
        }

        @media (max-width: 768px) {
            width: calc(50% - 10px);
        }
    }

    .name {
        position: relative;
        padding-left: 16px;
        color: #393D4B;

        &::before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            display: block;
            top: calc(50% - 3px);
            left: 0;
            background: #2563EB;
            position: absolute;
        }
    }

    .similarity {
        padding-left: 16px;
        color: #909FB5;
        font-size: 12px;
        color: #909FB5;
        margin: 4px 0 10px;
    }

    .byxx {
        width: 100%;
        background: #F4F7FB;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        color: #393D4B;
        padding: 6px 10px;
    }

    .line {
        width: 100%;
        height: 1px;
        margin: 16px 0;
        background: #F4F7FB;
        display: block;
    }

    .lqsj {
        font-weight: 600;
        font-size: 14px;
        color: #393D4B;

        i {
            font-size: 14px;
            color: #FA8932;
            margin-left: 8px;
        }
    }

    .lqxx {
        background: #EFF6FF;
        border-radius: 4px 4px 4px 4px;
        font-weight: 600;
        font-size: 14px;
        color: #2563EB;
        line-height: 20px;
        padding: 2px 10px;
        margin-top: 6px;
    }

    .lqzz {
        // background: #EFF6FF;
        // border-radius: 4px 4px 4px 4px;
        // font-weight: 600;
        font-size: 14px;
        color: #2563EB;
        line-height: 20px;
        padding: 2px 10px;
        margin-top: 6px;
    }

    .refresh {
        font-size: 14px;
        color: #6C7B92;

        // &:hover {
        //     color: #2563EB;
        // }
    }
}

.dark {
    background: #03162C;

    h6 {
        color: #fff;
    }

    .refresh {
        color: #fff;
    }
}
</style>